export interface Vec2 {
  x: number;
  y: number;
}

export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface Entity {
  id: string;
  position: Vec2;
  velocity: Vec2;
  width: number;
  height: number;
  active: boolean;
}

export interface GameState {
  scene: SceneType;
  paused: boolean;
  floor: number;
  runNumber: number;
  gameTime: number;
  floorTimer: number;  // seconds remaining on this floor (0 = no timer / boss floor)
}

export type SceneType = 'title' | 'lobby' | 'dungeon' | 'gameover' | 'victory';

export interface Camera {
  x: number;
  y: number;
  width: number;
  height: number;
  zoom: number;
}

export interface Tile {
  type: TileType;
  walkable: boolean;
  visible: boolean;
  explored: boolean;
}

export type TileType = 'floor' | 'wall' | 'door' | 'stairs' | 'shop' | 'cooking_station' | 'torch_yellow' | 'torch_green' | 'torch_red' | 'void';

export const TILE_SIZE = 32;
export const CANVAS_WIDTH = 960;
export const CANVAS_HEIGHT = 640;
